import Radio from '_com/menu/Radio'
import { mapGetters, mapMutations } from "vuex";
import { setNotifySetting } from '@/common/notifySettings'

import { 
  getAllRoomNotify,
  setNotify,
} from "_api/notify";
import { reportData } from '_api/report'
import EventBus from "_lib/EventBus";

import { ROOM_NOTIFY_SETTING_TYPES, ROOM_NOTIFY_SETTING_ENUM, DEFAULT_NOTIFY_SETTING } from '@/common/constants/room';

export default {
  name: '',
  props: {
  },
  components: {
    Radio,
  },
  data() {
    return {
      cur_notify_type: -1,
    }
  },
  computed: {
    ...mapGetters([
      'all_notify_settings',
      'channels',
      'cur_room_data'
    ])
  },
  methods: {
    generateNotifySettingSubmenu(room_id, channel) {
      let channel_id = channel?.channel_id
      try {
        //当前设置
        let currentNotifySetting = this.$unread.getNotifySetting({
          room_id,
          channel_id,
        }, false) || DEFAULT_NOTIFY_SETTING
        this.cur_notify_type = currentNotifySetting.notify_type
        //生成权限列表
        let list = Object.values(ROOM_NOTIFY_SETTING_TYPES)
        if (!channel_id) {
          list = list.filter(v => v.key !== ROOM_NOTIFY_SETTING_ENUM['extend'])
        } else {
          let { extend_type, parent_notify_type } = currentNotifySetting
          
          list[0].desc = ROOM_NOTIFY_SETTING_TYPES[ROOM_NOTIFY_SETTING_ENUM[parent_notify_type]].label
          list[0].label = `跟随${extend_type}默认`
        }
        //生成子菜单选项
        let notifySubMenu = list.map(setting => {
          let data = {
            label: setting.label,
            desc: setting.desc,
            key: setting.key,
            disable: false,
            active: setting.key == this.cur_notify_type,
            onClick: async () => {
              this.notifySubmenu?.forEach(obj => {
                this.$set(obj.data, 'active', setting.key === obj.data.key)
              });
              await this.setNotify(setting.key, room_id, channel_id, channel)
            }
          }
          return {
            component: 'menu-radio',
            data
          }
        })
        return notifySubMenu
      } catch (e) {
        return []
      }
    },
    async setNotify (notify_type, room_id, channel_id='', channel) {
      this.cur_notify_type = notify_type
      let currentNotifySetting = this.$unread.getNotifySetting({
        room_id,
        channel_id
      }, false) || DEFAULT_NOTIFY_SETTING
      currentNotifySetting.notify_type = notify_type
      let res = await setNotify({}, {
        ...currentNotifySetting,
        room_id,
        channel_id
      })
      
      if (res.data.status === "ok") {
        let channel_list_ids = []
        if (this.cur_room_data.room_id === room_id) {
          channel_list_ids = this.channels.filter(v => v.parent_id === channel_id).map(v => v.channel_id)
        }

        await setNotifySetting(room_id, channel_id, currentNotifySetting)
        this.$toast.success('设置成功')
        this.show = false
        this.$unread.updateUnreadStateCache({
          room_id,
          channel_id,
          channel_list_ids
        })
      }
    },
    ...mapMutations([
      'SET_ALL_NOTIFY_SETTINGS',
    ])
  }
}